import React from 'react';

import { Box } from '@mui/material';
import './Footer.css';

import logoGovBRCor from '../../../../assets/logo/logoGovBrColorido.svg';
import logoEbserhMEC from '../../../../assets/logo/logoHuBrasil.svg';

export function Footer() {
  return (
    <Box
      className="footerFaq"
      width="100%"
      height="12vh"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{ backgroundColor: '#071d41' }}
    >
      <img className="logoGovBrCor" src={logoGovBRCor} alt="logo govbr" />
      <img className="logoEbserhMec" src={logoEbserhMEC} alt="logo ebserh MEC" />
    </Box>
  );
}
